import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Button, MaterialIcon } from '@pearsontechnology/aero-components';

export const PaginatorWrapper = styled.div`
  padding-right: 10px;
  display: flex;
`;

export const PaginatorLink = styled(Link)`
  text-decoration: none;
`;

const Paginator = ({ list, value, constantRoute }) => {
  const currentIndex = list.map((x) => x.id).indexOf(value.id);
  const lengthOfList = list.length;
  const limitToEnds = (num) => {
    if (num < 0) {
      return 0;
    } else if (num >= lengthOfList) {
      return num - 1;
    }
    return num;
  };
  const prevValue = list[limitToEnds(currentIndex - 1)];
  const nextValue = list[limitToEnds(currentIndex + 1)];

  return (
    <PaginatorWrapper>
      {prevValue && currentIndex !== 0 ? (
        <PaginatorLink to={`${constantRoute}/${prevValue.id}`}>
          <Button iconOnly grey aria-label="Previous student" onClick={() => {}}>
            <MaterialIcon id="chevron_left" />
          </Button>
        </PaginatorLink>
      ) : (
        <Button iconOnly grey disabled aria-label="Previous student" onClick={() => {}}>
          <MaterialIcon id="chevron_left" />
        </Button>
      )}

      {nextValue && currentIndex !== lengthOfList - 1 ? (
        <PaginatorLink to={`${constantRoute}/${nextValue.id}`}>
          <Button iconOnly grey aria-label="Next student" onClick={() => {}}>
            <MaterialIcon id="chevron_right" />
          </Button>
        </PaginatorLink>
      ) : (
        <Button iconOnly grey disabled aria-label="Next student" onClick={() => {}}>
          <MaterialIcon id="chevron_right" />
        </Button>
      )}
    </PaginatorWrapper>
  );
};

Paginator.propTypes = {
  list: PropTypes.array.isRequired,
  value: PropTypes.object,
  constantRoute: PropTypes.string,
};

export default Paginator;
